<template>
    <div aria-label="home search"
        class="flex items-center px-6 py-4 text-lg text-clay-800 transition-colors duration-200 ease-out bg-white border-2 shadow-lg cursor-pointer border-clay-500 hover:border-t-0 hover:border-b-2 search-open hover:border-clay-300 border-x-0  hover:shadow-2xl rounded-3xl"
        v-on:click.prevent="openSearch">

        <span class="hidden pr-2 text-lg text-clay-800 search-txt md:block">Search shows, characters, monologues, and more…</span>
        <span class="pr-2 text-lg text-clay-800 search-txt md:hidden">Search resources</span>
        <div class="absolute right-0 -mr-1">
            <div class="px-4 py-4 bg-sa-raspberry-400 rounded-r-3xl">
                <MagnifyingGlassIcon aria-hidden="true" class="inline-block w-6 h-6 text-white " />
                <span class="hidden inline-block pl-2 text-white uppercase text-md"> Search</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {ref} from "vue";
import {MagnifyingGlassIcon} from '@heroicons/vue/20/solid';
import {store} from "@/store";

const openSearch = async () => {
    store.openSearchDialog = true;
};

</script>
<style>

</style>